<template>
  <div>
    <ProcessGroup :selectedItems="selected_requests" type="moveAllWaitingRequests" />
    <div v-if="!this.$store.state.waitingNewLoading" style="margin-top: 40px">
      <div v-if="$store.state.views === 'cards'">
        <div v-if="this.$store.state.waitingNewData.length > 0">
          <RequestsCard
            :CardData="this.$store.state.waitingNewData"
            @pageCount="handlePageNumber"
            @back="handleBack"
          />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
        <div v-else>
          <div>
            <button
              @click="handleBack"
              style="
                width: 70px;
                height: 40px;
                border-radius: 5px;
                margin: 50px;
                color: white;
                background-color: #441545;
                direction: ltr;
              "
            >
              رجوع
            </button>
          </div>
          <div class="noData">لا يوجد بيانات</div>
        </div>
      </div>
      <div v-else-if="$store.state.views === 'table'" class="table__view">
        <table-component
          :showSelect="true"
          itemKey="id"
          :selectedRows.sync="selected_requests"
          :headers="headers"
          :pagination="this.$store.state.pagination"
          :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData"
          :loading="loading"
          @refresh="getTableData"
          v-model="page"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#3f0e40" small depressed dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <AddNewProcess :item="item.id" :request_id="item.request_id" />
              </v-list>
            </v-menu>
          </template>

          <template slot="item.agent_class_note" slot-scope="props">
            <classification-cell
              :label="props.item.class_id_agent_text"
              :color="props.item.class_id_agent_color"
              :name="props.item.agent_name"
              :note="props.item.agent_notes"
              :date="props.item.comment_date"
            />
          </template>
          <template slot="item.cs_class_note" slot-scope="props">
            <classification-cell
              :label="props.item.class_id_cs_text"
              :color="props.item.class_id_cs_color"
              :name="props.item.customer_service_name"
              :note="props.item.cs_note"
              :date="props.item.customer_service_note_date"
            />
          </template>

          <template slot="item.comment" slot-scope="props">
            <span v-if="!props.item.comment"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.comment.length > 30
                    ? props.item.comment.substring(0, 30) + "..."
                    : props.item.comment
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.comment }}</div>
            </v-tooltip>
          </template>
        </table-component>
        <OrderRequestSection
          v-if="this.$store.state.openOrderRequestSection"
          style="margin-top: 50px"
        />
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      "
      v-else
    >
      <LoadingMore />
    </div>
    <QualityDialog :selectedItems="selected_requests" />
    <AdminDialog
      @selectedValue="selectedValue"
      :items="this.$store.state.allStatusAgent"
      label="استشاري المبيعات"
    />
    <OrderRequestDialog />
    <CallsDialog />
  </div>
</template>

<script>
import Axios from "axios";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import RequestsCard from "@/components/Charts/RequestsCard.vue";
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import { formatDate } from "@/mixins/formatDate";
import { SourceValue } from "@/mixins/sourceValue";
import AddNewProcess from "@/views/admin/Requests/MoveToNew/AddNewProcess.vue";
import AdminDialog from "@/components/AdminComponent/AdminDialog.vue";
import ProcessGroup from "@/views/admin/Requests/MoveToNew/ProcessGroup.vue";
import QualityDialog from "@/components/AdminComponent/QualityDialog.vue";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import ClassificationCell from "@/components/Base/ClassificationCell.vue";

export default {
  name: "AdminSupport",
  components: {
    QualityDialog,
    ProcessGroup,
    AdminDialog,
    AddNewProcess,
    RequestsCard,
    LoadingMore,
    OrderRequestDialog,
    OrderRequestSection,
    CallsDialog,
    ClassificationCell,
  },

  data() {
    return {
      page: 1,
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      selected_requests: [],
      allGetData: [],
      allRequests: [],
      headers: [
        { align: "center", value: "data-table-select" },
        {
          text: "تاريخ انشاء طلب التحويل",
          value: "تاريخ انشاء طلب التحويل",
          width: "120px",
          align: "center",
        },
        {
          text: "تاريخ دخول الطلب الي النظام",
          value: "تاريخ دخول الطلب الي النظام",
          width: "120px",
          align: "center",
        },
        { text: "حاله الطلب", value: "حاله الطلب", width: "120px", align: "center" },
        { text: "عميل", value: "عميل", width: "130px", align: "center" },
        { text: "الجوال", value: "الجوال", align: "center" },
        {
          text: "مصدر المعامله",
          value: "مصدر المعامله",
          width: "120px",
          align: "center",
        },
        {
          text: "الأستشاري",
          value: "agent_class_note",
          width: "180px",
          align: "center",
          sortable: false,
        },
        {
          text: "خدمة العملاء",
          value: "cs_class_note",
          width: "180px",
          align: "center",
          sortable: false,
        },
        { text: "الملاحظه", value: "comment", width: "130px", align: "center" },
        { text: "العمليه", value: "العمليه", width: "140px", align: "center" },
        { text: "", value: "action", align: "center" },
      ],
    };
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  methods: {
    handleBack() {
      this.$store.state.waitingNewData = [];
      this.$store.state.tableData = [];
      this.$store.state.waitingNewLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getAllRequests(1, "back");
    },
    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getAllRequests(val);
      } else {
        this.searchRequest(val);
      }
    },
    searchRequest(page, type) {
      this.loading = true;

      if (type === "table") {
        this.$store.state.tableData = [];
      }

      if (page > 1 || type === "table") {
        this.$store.state.bodySearch.delete("page");
        this.$store.state.bodySearch.append("page", page);

        let url = `${this.$store.state.url}/v2/employee/Requests/search?type=waiting_list_new`;
        Axios.post(url, this.$store.state.bodySearch, {
          headers: this.request_headers(),
        }).then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          let response = res.data.payload.data;
          response.map((item) => {
            if (item.length === 0) {
              this.loading = false;
            }
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.waitingNewSearch.push(...response);
          this.removeDublicate(this.$store.state.waitingNewSearch);
          this.loading = false;
        });
      }
    },

    selectedValue(itemSelected) {
      this.getAgentRequest(itemSelected);
    },

    getAgentRequest(itemSelected) {
      let body = new FormData();

      body.append("request_ids[0]", this.$store.state.selectId);
      body.append("agents_ids[0]", itemSelected.id);

      Axios.post(
        `${this.$store.state.url}/v2/employee/Requests/moveAllWaitingRequests`,
        body,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.showPopup("success", res.data.message);
        })
        .catch((err) => {
          let error = { err };
          let message = error.err.response.data.message[0];
          this.showPopup("error", message);
        });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=waiting_list_new&page=${count}&per_page=${this.$store.state.counterOfShow}`,
        { headers: this.request_headers() }
      ).then((res) => {
        res.data.payload.data.map((item) => {
          this.setTbData(item);
        });
        this.loading = false;
      });
    },

    setTbData(items) {
      this.$store.state.tableData.push({
        id: items.id,
        "تاريخ انشاء طلب التحويل": items.request.agent_date
          ? formatDate(items.request.agent_date)
          : "",
        "تاريخ دخول الطلب الي النظام": items.request.created_at
          ? formatDate(items.request.created_at)
          : "",
        "حاله الطلب": items.request.status,
        "استشاري المبيعات": items.request.user?.name,
        عميل: items.request.customer.name,
        الجوال: items.request.customer.mobile,
        "مصدر المعامله": SourceValue(items.request.source),
        class_id_agent_text: items.request.class_id_agent_text ?? null,
        class_id_agent_color: items.request.class_id_agent_color ?? null,
        agent_name: items.request.agent_name ?? items.request.user?.name ?? null,
        agent_notes:
          items.request.agent_notes ??
          items.request.agent_note ??
          items.request.comment ??
          null,
        comment_date: items.request.comment_date ?? null,
        class_id_cs_text: items.request.class_id_cs_text ?? null,
        class_id_cs_color: items.request.class_id_cs_color ?? null,
        customer_service_name:
          items.request.customer_service_name ??
          items.request.customer_service?.name ??
          null,
        cs_note:
          items.request.cs_note ?? items.request.customer_service_note ?? null,
        customer_service_note_date: items.request.customer_service_note_date
          ? formatDate(items.request.customer_service_note_date)
          : (items.request.customer_service_note_date ?? null),
        comment: items.request.comment,
        request_id: items.request.id,
        العمليه: items.action,
      });
    },

    getAllRequests(count) {
      if (
        this.$store.state.waitingNewData.length === 0 &&
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.waitingNewLoading = true;
      }
      this.loadMoreData = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=waiting_list_new&page=${count}&per_page=${this.$store.state.counterOfShow}`,
        { headers: this.request_headers() }
      )
        .then((res) => {
          let response = res.data.payload.data.map((item) => {
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_waiting_list_new,
          };

          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          this.loadingData = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.loadingData = false;
        });
    },
    removeDublicate(array) {
      let uniqueArray = array.filter((item, index) => {
        return (
          index ===
          array.findIndex((obj) => {
            return obj.id === item.id; // Compare based on the 'id' property
          })
        );
      });
      this.$store.state.waitingNewData = uniqueArray;

      this.$store.state.waitingNewLoading = false;
    },
  },

  created() {
    this.$store.state.waitingNewData = [];
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.bodySearch = new FormData();
    this.$store.state.isSearch = false;
    this.getAllRequests(1);
    this.$store.state.startElement = [];
    this.$store.state.views = "cards";
  },
};
</script>

<style>
.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}
</style>
